'use client'

import type { ReactNode } from 'react'
import { getClassNames } from '@helpers/productWidgetHelper'

const AbhaDownloadIcon = () => (
  <svg width="1.125rem" height="1.125rem" viewBox="0 0 18 18" fill="none" aria-hidden>
    <path
      d="M9 2.25V11.25M9 11.25L5.625 7.875M9 11.25L12.375 7.875M3.375 13.5H14.625"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export type AbhaHeroSuccessActionButtonProps = {
  label: string
  onClick: () => void
  fullWidth?: boolean
  className?: string
  trailingIcon?: ReactNode
}

export const AbhaHeroSuccessActionButton = ({
  label,
  onClick,
  fullWidth = false,
  className,
  trailingIcon,
}: AbhaHeroSuccessActionButtonProps) => (
  <button
    type="button"
    className={getClassNames(['abha-hero-success__download-btn', className ?? ''], {
      'abha-hero-success__download-btn--full': fullWidth,
    })}
    onClick={onClick}>
    <span>{label}</span>
    {trailingIcon ?? <AbhaDownloadIcon />}
  </button>
)
